import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'chatHeaderFloatingIconLabel'
	| 'chatHeaderFloatingButtonText'
	| 'chatHeaderSidebarIconLabel'
	| 'chatHeaderSidebarButtonText'
	| 'chatHeaderSwitchModeSectionText'
	| 'chatHeaderSwitchModeButtonLabel'
	| 'chatHeaderFullscreenIconLabel'
	| 'chatHeaderFullscreenButtonText'
	| 'chatHeaderFullscreenInHomeIconLabel'
	| 'chatHeaderFullscreenInHomeButtonText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		chatHeaderFloatingIconLabel: {
			id: 'ai-mate.rovo-chat-header.floating-icon-label',
			defaultMessage: 'Floating',
			description: 'Label for the header floating icon',
		},
		chatHeaderFloatingButtonText: {
			id: 'ai-mate.rovo-chat-header.floating-button-text',
			defaultMessage: 'Floating',
			description: 'Text for the header floating button text',
		},
		chatHeaderSidebarIconLabel: {
			id: 'ai-mate.rovo-chat-header.sidebar-icon-label',
			defaultMessage: 'Sidebar',
			description: 'Label for the header sidebar icon',
		},
		chatHeaderSidebarButtonText: {
			id: 'ai-mate.rovo-chat-header.sidebar-button-text',
			defaultMessage: 'Sidebar',
			description: 'Text for the header sidebar button text',
		},
		chatHeaderSwitchModeSectionText: {
			id: 'ai-mate.rovo-chat-header.switch-mode-section-text',
			defaultMessage: 'Switch to',
			description: 'Text for the header switch mode section',
		},
		chatHeaderSwitchModeButtonLabel: {
			id: 'ai-mate.rovo-chat-header.switch-mode-button-label',
			defaultMessage: 'Switch to',
			description: 'Label for the header switch mode button',
		},
		chatHeaderFullscreenIconLabel: {
			id: 'ai-mate.rovo-chat-header.fullscreen-icon-label',
			defaultMessage: 'Full screen',
			description: 'Label for the header fullscreen icon',
		},
		chatHeaderFullscreenButtonText: {
			id: 'ai-mate.rovo-chat-header.fullscreen-button-text',
			defaultMessage: 'Full screen',
			description: 'Text for the header fullscreen button text',
		},
		chatHeaderFullscreenInHomeIconLabel: {
			id: 'ai-mate.rovo-chat-header.fullscreen-in-home-icon-label.non-final',
			defaultMessage: 'Open in Home',
			description: 'Label for the header fullscreen in home icon',
		},
		chatHeaderFullscreenInHomeButtonText: {
			id: 'ai-mate.rovo-chat-header.fullscreen-in-home-button-text.non-final',
			defaultMessage: 'Open in Home',
			description: 'Text for the header fullscreen in home button',
		},
	});

export default message;
